/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/**
 * Client-side constants cho OAuth Authorization Code Flow.
 * Doc: OAUTH_INTERGATION.md §2.
 */
export const ACCOUNTS_URI =
  process.env.NEXT_PUBLIC_ACCOUNTS_URI || 'https://accountsstg.ahamove.com';

/** OAuth client ID — phải khớp với OAUTH_CLIENTS_JSON ở accounts. */
export const CLIENT_ID = process.env.NEXT_PUBLIC_AHAFOOD_CLIENT_ID || 'ahafood';

/** sessionStorage key cho redirect target sau login (giữ qua bounce SSO). */
export const AUTH_REDIRECT_KEY = 'ahafood_auth_redirect';

/**
 * localStorage flag: set khi user chủ động logout → lần login kế tiếp gửi
 * `prompt=login` để accounts tự đăng xuất session .ahamove.com + hiện form
 * (thay cho việc redirect xoá cookie lúc logout). Consume (xoá) ngay khi dùng.
 */
export const FORCE_LOGIN_KEY = 'ahafood_force_login';

/**
 * Build accounts SSO URL với client_id (OAuth code flow).
 * Doc §5.1.
 * @param prompt - 'login' để ép accounts đăng xuất + hiện form (bỏ silent SSO).
 */
export function buildAccountsSignInUrl(
  redirectUri: string,
  state: string,
  opts?: { prompt?: 'login' }
): string {
  const url = new URL('/sign-in', ACCOUNTS_URI);
  url.searchParams.set('redirect_uri', redirectUri);
  url.searchParams.set('client_id', CLIENT_ID);
  url.searchParams.set('state', state);
  if (opts?.prompt) url.searchParams.set('prompt', opts.prompt);
  return url.toString();
}

/** Same-origin safe redirect target. */
export function safeRedirectTarget(target: string | null): string {
  if (!target) return '/';
  if (target.startsWith('/') && !target.startsWith('//')) return target;
  try {
    const url = new URL(target);
    if (url.origin === window.location.origin) return url.pathname + url.search;
  } catch {
    /* ignore */
  }
  return '/';
}
